import {SimpleModal} from '@modules/simple-modal';
import {modals as modalEnumerate} from '../constants-enumerate';

const modals = {
  [modalEnumerate.SAVE_GROUP_SEARCH_RESULTS]: {
    resolve: () => import('../save-group-search-modal')
  },
  [modalEnumerate.SAVE_USER_SEARCH_RESULTS]: {
    resolve: () => import('../save-user-search-modal')
  },
  [modalEnumerate.INVITATION]: {
    resolve: () => import('../invitation-modal')
  },
  [modalEnumerate.LICENSE_ASSIGN_BULK]: {
    resolve: () => import('../license-assign-modal')
  },
  [modalEnumerate.LICENSE_REVOKE_BULK]: {
    resolve: () => import('../license-bulk-revoke-modal')
  },
  [modalEnumerate.STUDENT_DETAILS]: {
    resolve: () => import('../student-detail-modal')
  },
  [modalEnumerate.ARCHIVED_STUDENT]: {
    resolve: () => import('../archived-student-modal')
  },
  [modalEnumerate.ARCHIVED_TEACHER]: {
    resolve: () => import('../archived-teacher-modal')
  },
  [modalEnumerate.DID_YOU_KNOW]: {
    resolve: () => import('../../routes/dashboard/modules/did-you-know-modal')
  },
  [modalEnumerate.LICENSE_REVOKE]: {
    resolve: () => import('../license-revoke-modal')
  },
  [modalEnumerate.LICENSE_EXPLAIN]: {
    resolve: () => import('../license-explain-modal')
  },
  [modalEnumerate.CSV_COL_ERROR]: {
    resolve: () => import('../csv-col-error-modal')
  },
  [modalEnumerate.CSV_ROW_ERROR]: {
    resolve: () => import('../csv-row-error-modal')
  },
  [modalEnumerate.STUDENT_DELETE]: {
    resolve: () => import('../student-delete-modal')
  },
  [modalEnumerate.ABCMOUSE_PASSCODE]: {
    resolve: () => import('../product-card-info/modules/abcmouse-passcode-modal')
  },
  [modalEnumerate.ABCMOUSE_PASSCODE_RESET]: {
    resolve: () => import('../product-card-info/modules/abcmouse-passcode-reset-modal')
  },
  [modalEnumerate.PRODUCT_ACTIVATION]: {
    resolve: () => import('../../routes/dashboard/modules/product-activation-modal')
  },
  [modalEnumerate.CONFIRM_TEACHER_LOGIN_CHANGE]: {
    resolve: () => import('../../routes/teachers/modules/confirm-login-change-modal')
  },
  [modalEnumerate.DISCONNECT]: {
    resolve: () => import('../../routes/rosters/modules/disconnect-modal')
  },
  [modalEnumerate.CONNECT_TP_ROSTER]: {
    resolve: () => import('../../routes/rosters/modules/connect-modal')
  },
  [modalEnumerate.CLASSLINK_APP_VISIBILITY]: {
    resolve: () => import('../../routes/rosters/modules/classlink-app-visibility-modal')
  },
  [modalEnumerate.RESOURCE_INFO]: {
    resolve: () => import('../../routes/resources/modules/resource-info-modal')
  },
  [modalEnumerate.RESOURCE_PRINT_REPORT]: {
    resolve: () => import('../../modules/print-reports-modal')
  },
  [modalEnumerate.TEACHER_DETAIL]: {
    resolve: () => import('../../routes/teachers/modules/teacher-detail-modal')
  },
  [modalEnumerate.ORG_GROUP_DETAILS]: {
    resolve: () => import('../org-group-details-modal')
  },
  [modalEnumerate.ARCHIVED_GROUP]: {
    resolve: () => import('../archived-group-modal')
  },
  [modalEnumerate.CLASS_EDIT]: {
    resolve: () => import('../class-edit-modal')
  },
  [modalEnumerate.ARCHIVED_CLASS]: {
    resolve: () => import('../archived-class-modal')
  },
  [modalEnumerate.ADMIN_DETAIL]: {
    resolve: () => import('../admin-detail-modal')
  },
  [modalEnumerate.ADMIN_CHANGE_PASSWORD]: {
    resolve: () => import('../admin-change-password-modal')
  },
  [modalEnumerate.ACADEMY_LESSON_DETAILS_MODAL]: {
    resolve: () => import('../academy-lesson-details-modal')
  },
  [modalEnumerate.PICTURE_PASSCODE_RESET]: {
    resolve: () => import('../bulk-picture-passcode-reset-modal')
  },
  [modalEnumerate.PARENT_REDEEM_CODE]: {
    resolve: () => import('../../routes/parent/modules/redeem-code-modal')
  },
  [modalEnumerate.LICENSE_CONFLICT_MODAL]: {
    resolve: () => import('../license-conflict-modal')
  },
  [modalEnumerate.NO_MORE_LICENSE_AVAILABLE]: {
    resolve: () => import('../no-more-license-available-modal')
  },
  [modalEnumerate.ROSTER_ERRORS_MODAL]: {
    resolve: () => import('../../routes/upload-roster/modules/roster-errors-modal')
  },
  [modalEnumerate.MFA_ENTER]: {
    resolve: () => import('../mfa-enter-modal')
  },
  [modalEnumerate.MFA_SELECT]: {
    resolve: () => import('../mfa-select-modal')
  },
  [modalEnumerate.MFA_SETUP]: {
    resolve: () => import('../mfa-setup-modal')
  },
  [modalEnumerate.STUDENT_RECOMMENDED_ACTIVITY_DETAILS]: {
    resolve: () => import('../student-recommended-activity-details-modal')
  },
  [modalEnumerate.DASHBOARD_GROUP_MODAL]: {
    resolve: () => import('../dashboard-group-modal')
  },
  [modalEnumerate.GENERATE_QR]: {
    resolve: () => import('../generate-qr-modal')
  },
  [modalEnumerate.CANCEL_ROSTER_JOB_CONFIRMATION_MODAL]: {
    resolve: () => import('../cancel-roster-job-confirmation-modal')
  },
  [modalEnumerate.SINGLE_SKILL_CARD_MODAL]: {
    resolve: () => import('../single-skill-card-modal')
  },
  [modalEnumerate.UPDATE_LOGIN_EMAIL]: {
    resolve: () => import('../update-login-email-modal')
  },
};

SimpleModal.addModals(modals);
